<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('title.permissionSearch')" type="confirm" width="40%" @confirm="confirm">
    <vxe-table
      ref="table"
      :data="data"
      :loading="loading"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="40"/>
      <vxe-column field="permissionNo" title="business.label.permissionNo"/>
      <vxe-column field="permissionEffectiveDate" title="business.label.effectiveTime"/>
      <vxe-column field="permissionExpirationDate" title="business.label.expirationTime"/>
    </vxe-table>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import api from '@/api'

export default {
  name: 'PermissionModal',
  props: {
    selectType: { type: String, default: 'radio' }
  },
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      query: { 'itemId': null },
      args: null,
      selectedRows: [],
      record: undefined
    }
  },
  methods: {
    init(args) {
      this.query = { 'itemId': null }
      this.data = []
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e) {
      this.init(args)
      this.record = e
      this.visible = true
      this.fetch()
    },
    fetch() {
      this.loading = true
      post(api.receivingAsnGetPermissions, null, null, this.query).then(res => {
        if (res.success) {
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        const radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      if (selectedRows.length > 0) this.$emit('change', selectedRows, this.record)
      this.visible = false
    }
  }
}
</script>